import React from 'react';
import gif from '../../../images/giphy.gif';

const Conform = () => {
    return (
        <div>
            <div className="d-flex justify-content-center">
                <img src={gif} className="img-fluid" alt="" />
            </div>
        </div>
    );
};

export default Conform;